export default __webpack_public_path__ + "static/media/personal_on_demand.5e17c8fc.svg";